import axios from 'axios'

export default {
  namespaced: true,

  state: {
    faqs: [],
    count: 0
  },

  getters: {},

  mutations: {
    SET_FAQS (state, faq) {
      state.faqs = faq.list
    },

    SET_COUNT (state, data) {
      state.count = data.count
    },

    UPDATE_FAQ (state, faqs) {
      state.faqs.forEach((data) => {
        faqs.forEach((faq) => {
          if (data.id === faq.id) {
            data.title = faq.title
            data.content = faq.content
          }
        })
      })
    }
  },

  actions: {
    async get ({ commit }, { status, params }) {
      let result = await axios
        .get(`/faqs/${status}`, { params })

      commit('SET_FAQS', result.data)
      commit('SET_COUNT', result.data)
      return result.data
    },

    async create ({ commit }, faq) {
      let result = await axios
        .post('/faqs', faq)

      return result
    },

    async update ({ commit }, faqs) {
      let result
      for (let a = 0; a < faqs.length; a++) {
        result = await axios
          .patch(`/faqs/${faqs[a].id}`, faqs[a])
      }

      commit('UPDATE_FAQ', faqs)
      return result
    }
  }
}
